(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["suba"] = factory();
	else
		root["suba"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validator = __webpack_require__(1);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Suba = {
	  Validator: _validator2.default
	};
	
	exports.default = Suba;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Validator = {
	  // 判断手机有效性
	  // 手机号码
	  // 移动：134[0-8],135,136,137,138,139,150,151,157,158,159,182,187,188
	  // 联通：130,131,132,152,155,156,185,186
	  // 电信：133,1349,153,180,181,189
	  validPhone: function validPhone(phone) {
	    phone = phone || '';
	    // var regexTestPhone = /^1(3[0-9]|5[0-35-9]|8[0125-9])\d{8}$/;
	    // // 中国移动
	    // var regexTestChinaMobile = /^1(34[0-8]|(3[5-9]|5[017-9]|8[278])\d)\d{7}$/;
	    // // 中国联通
	    // var regexTestChinaUnicome = /^1(3[0-2]|5[256]|8[56])\d{8}$/;
	    // // 中国电信
	    // var regexTestChinaTelecom = /^1((33|53|8[019])[0-9]|349)\d{7}$/;
	    // return regexTestPhone.test(phone) &&
	    // (regexTestChinaMobile.test(phone) ||
	    // regexTestChinaUnicome.test(phone) ||
	    // regexTestChinaTelecom.test(phone));
	    return (/^1\d{10}$/.test(phone)
	    );
	  },
	
	
	  // 验证token是否有效
	  validToken: function validToken(timestamp, expires_in) {
	    var result = null;
	    var scale = 1000;
	    if (!timestamp || !expires_in || typeof timestamp !== 'number' || typeof expires_in !== 'number') {
	      result = false;
	    } else {
	      result = new Date().getTime() < timestamp + expires_in * scale;
	    }
	    return result;
	  }
	};
	
	exports.default = Validator;
	module.exports = exports['default'];

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** suba.min.js
 **/